export default __webpack_public_path__ + "static/media/ic_north_korea.30ff505b.svg";